import { Container } from "@mantine/core"
import React from "react"
import styles from "./CPContainer.module.css"

interface CPContainerProps {
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "full"
	children: React.ReactNode
	px?: number | object
	py?: number | object
	pt?: number | object
	pb?: number | object
	h?: string | number
	mih?: string | number
	w?: string | number
	className?: string
}

const CPContainer: React.FC<CPContainerProps> = ({
	size = "full",
	children,
	px,
	py,
	pt,
	pb,
	h,
	mih,
	w,
	className
}) => {
	return (
		<Container
			size={size}
			px={px}
			py={py}
			pt={pt}
			pb={pb}
			style={{
				maxWidth: "1440px",
				margin: "0 auto",
				height: h,
				minHeight: mih,
				width: w
			}}
			className={` ${styles.cpContainer} ${className || ""}`}
		>
			{children}
		</Container>
	)
}

export default CPContainer
